import React, { useState, useEffect, useRef } from 'react'

export default function TurnstileForm({setToken}) {
    const captchaRef = useRef(null)

    useEffect(() => {
        const scriptId = 'cf-turnstile-script'
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script')
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
            script.async = true
            script.defer = true
            script.id = scriptId
            document.body.appendChild(script)
            script.onload = initializeTurnstile
        } else {
            initializeTurnstile()
        }

        function initializeTurnstile() {
            if (captchaRef.current && !captchaRef.current.hasChildNodes()) {
                if (window.turnstile) {
                    window.turnstile.render(captchaRef.current, {
                        sitekey: '0x4AAAAAAA9MWKZ_AXDg-8n_',
                        callback: (t) => {
                            setToken(t)
                        }
                    })
                }
            }
        }
    }, [])


    return (
        <div ref={captchaRef}></div>
    )
}
